import { render } from "./AboutCallAction.vue?vue&type=template&id=bc9485c4&scoped=true"
import script from "./AboutCallAction.vue?vue&type=script&lang=js"
export * from "./AboutCallAction.vue?vue&type=script&lang=js"

import "./AboutCallAction.vue?vue&type=style&index=0&id=bc9485c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9485c4"]])

export default __exports__